import { createGlobalStyle } from 'styled-components';

const VariationsStyles = createGlobalStyle`
  .generated-images-holder {
    position: absolute;
    bottom: 100%;
    right: 100%;
    width: 1200px;

  }
  .image-holder {
    width: 100%;
    display: flex;
    position: relative;
    height: 630px;
    padding: 53px 63px;
  }

  .inner-div {
    background-color: white;
    width: 100%;
    padding: 52px 56px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .channel-row {
    display: flex;
    align-items: center;
    margin-bottom: 38px;
  }

  .channel-image {
    flex-shrink: 0;
    width: 63px;
    height: 63px;
    border-radius: 50%;
    margin-right: 20px;
  }

  .channel-name {
    font-family: Arial, Helvetica, sans-serif;
    color: #000;
    font-size: 39px;
    font-weight: 700;
  }

  .channel-name__blue {
    color: #3D5798;
  }

  .text {
    font-family: Arial, Helvetica, sans-serif;
    color: #000;
    font-size: 66px;
    line-height: 1.2;
    font-weight: 400;
  }
`;

export default VariationsStyles;
